import { Component, Vue } from "vue-property-decorator";

@Component
export default class ProjectPublished extends Vue {
  render() {
    return (
      <svg
        width="80"
        height="80"
        viewBox="0 0 80 80"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="0.5"
          y="0.5"
          width="79"
          height="79"
          rx="15.5"
          stroke="#0C0A09"
        />
        <path
          d="M38.7002 33.3125L20.5 43.9287V35.4863L38.7002 24.8701V33.3125Z"
          fill="#0C0A09"
          stroke="#0C0A09"
        />
        <path
          d="M38.7002 46.6865V55.1289L20.5 44.5127V36.0703L38.7002 46.6865Z"
          fill="#0C0A09"
          stroke="#0C0A09"
        />
        <path
          d="M59.4996 45.3145L42.9 55.123V34.6846L59.4996 24.876V45.3145Z"
          fill="#0C0A09"
          stroke="#0C0A09"
        />
      </svg>
    );
  }
}
